import { useMutation } from "@apollo/client";

import { RemovePartnerFromGoalMutation, RemovePartnerFromGoalMutationVariables } from "@ctypes";
import { REMOVE_PARTNER_FROM_GOAL, USER } from "@graphql";

export const useRemovePartnerFromGoal = () => {
  return useMutation<RemovePartnerFromGoalMutation, RemovePartnerFromGoalMutationVariables>(
    REMOVE_PARTNER_FROM_GOAL,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
